// Card #2285 -- deliberate product decision by Jaybill McCarthy, 2026-09-04:
// on the PUBLIC surfaces only (score-fe's rider portal and the public
// scoreboard), a ride's final percentage strictly below 55 is suppressed at
// render. This decision runs AGAINST USEF DR123.2 and DR123.3
// (docs/rules/usef/rulebook-dr-dressage-2026.pdf, USEF Rulebook Chapter DR,
// current 2026 edition), both of which REQUIRE every score and every final
// result to be published, with no low-score exception:
//   DR123.2: "Scores must be posted on a public scoreboard as soon as
//   possible after each ride."
//   DR123.3: "Final results for each class must be posted ... and all
//   results must include total points and percentages."
// The rule conflict was found and cited to Jaybill before any code was
// written (card #2285 comment thread), and he chose to proceed anyway,
// scoped to the scoreboard and the public displays -- his call as product
// owner, made with the conflict in front of him. The conflict is NOT
// resolved, it is accepted. This comment exists so a future reader can see
// this was CHOSEN, not missed, never mistaken for a rulebook requirement of
// our own (no USEF/USDF rule suppresses sub-55% scores; real dressage
// results publish them).
//
// Hard constraint: this module decides render-time VISIBILITY ONLY. It
// never mutates a stored score, a ride's percentage, a placing, USEF/USDF
// results reporting, report artifacts, or the audit trail -- every one of
// those keeps the true number regardless of what this returns. Staff
// surfaces (scribe-fe, scoreadmin-fe, announcer-fe) never import this file
// and always show the real number.
export const PUBLIC_SCORE_FLOOR = 55;

// Strictly below 55 hides (54.9 -> false); 55.0 and above shows (55.0,
// 55.1 -> true). Any non-finite/non-numeric value (null, undefined, a
// string, NaN) is not "publicly visible" either -- there is no score to
// show, so callers already have their own not-scored-yet branch to fall
// into instead of treating this as a false positive.
export function isScorePubliclyVisible(percentage) {
  return (
    typeof percentage === "number" &&
    Number.isFinite(percentage) &&
    percentage >= PUBLIC_SCORE_FLOOR
  );
}
